import { SignedIn, SignedOut, SignInButton } from "@clerk/clerk-react";
import { LogIn } from "lucide-react";
import React, { type ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface AuthenticatedPageWrapperProps {
	children: ReactNode;
	toolName?: string;
}

export default function AuthenticatedPageWrapper({
	children,
	toolName = "dieses Tool",
}: AuthenticatedPageWrapperProps) {
	return (
		<>
			<SignedIn>{children}</SignedIn>
			<SignedOut>
				<div className="flex min-h-[calc(100vh-20rem)] flex-col items-center justify-center">
					<Card className="w-full max-w-md border border-gray-100 bg-white/80 text-center shadow-xl backdrop-blur-sm dark:border-gray-700 dark:bg-gray-800/80">
						<CardHeader className="pb-2">
							<CardTitle className="text-2xl text-indigo-600 dark:text-indigo-400">
								Anmeldung erforderlich
							</CardTitle>
						</CardHeader>
						<CardContent className="pt-2">
							<p className="mb-6 text-gray-600 dark:text-gray-300">
								Bitte melde dich an, um {toolName} nutzen zu können.
							</p>
							<SignInButton mode="modal">
								<Button
									className="w-full bg-indigo-600 text-white transition-all hover:bg-indigo-700 dark:bg-indigo-700 dark:hover:bg-indigo-800"
									size="lg"
								>
									<LogIn className="mr-2 h-5 w-5" />
									Anmelden
								</Button>
							</SignInButton>
						</CardContent>
					</Card>
				</div>
			</SignedOut>
		</>
	);
}
